import { getBooleanishTruthy } from '@brandfolder/utilities';
import React, { forwardRef } from 'react';

const BaseLink = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { 'aria-disabled': ariaDisabled, children, disabled, href, loading, onClick, ...otherProps } = props;
    const isDisabled = getBooleanishTruthy(ariaDisabled) || disabled || undefined;
    return /*#__PURE__*/ React.createElement("a", {
        ...otherProps,
        "aria-disabled": isDisabled,
        href: !isDisabled && !loading ? href : undefined,
        onClick: !isDisabled && !loading ? onClick : undefined,
        ref: ref
    }, children);
});

export { BaseLink };
//# sourceMappingURL=base-link.js.map
